import { useEffect } from 'react';

import { Footer, Row, Col, Banner } from 'darrius';

import { AdsPriceCards, AdsHeroSection } from './partials';

import { Header } from '../../components/atoms';
import { HeadContent } from '../../components';

import { triggerEvent } from '../../utils/triggerEvent';

import { IAnunciosTemplateProps } from './@interface';

import styles from './AdsTemplate.module.scss';

export default function AdsTemplate({
  adsPageProps,
  staticContent,
  isInstantMatch = false,
  requestId = null,
  isUserCliAuthenticated = false,
  noindex = false,
}: IAnunciosTemplateProps) {
  const {
    meta,
    mainSection,
    categorySlug,
    user,
    rating,
    isSentMessage,
    requestUuid,
  } = adsPageProps;

  const { footerContent } = staticContent;

  const heroSectionData = {
    user,
    requestId,
    mainSection,
    rating,
    isSentMessage,
    requestUuid,
  };

  useEffect(() => {
    const trackingTimeout = setTimeout(() => {
      if (isInstantMatch && !!requestId && !!user.id) {
        triggerEvent('instant-match_service-sale-ads__inicialization', {
          requestId: requestId,
          profileId: user.id,
        });
      }
    }, 1000);

    return () => clearTimeout(trackingTimeout);
  }, [user, requestId]);

  return (
    <>
      <HeadContent
        metaTitle={meta.title}
        slug={categorySlug}
        metaDescription={meta.description}
        type="instant-contact-profile-ads:show"
        noindex={noindex}
      />
      <Header.Simple />
      <main
        className={`profile-page-internal ${styles['profile-page']} ${styles.internal}`}
        data-category-slug={categorySlug}
      >
        <AdsHeroSection
          heroSectionData={heroSectionData}
          isInstantMatch={isInstantMatch}
          isUserCliAuthenticated={isUserCliAuthenticated}
        />

        <Banner as="section" className="full space-top">
          <Row>
            <Col className={`col-sm-12 col-md-8`}>
              <AdsPriceCards
                isUserCliAuthenticated={isUserCliAuthenticated}
                pricesCard={user.partner.prices}
                requestId={requestId}
                profileId={user.id}
                adsPageProps={adsPageProps}
                requestUuid={requestUuid}
                user={user}
              />
            </Col>
          </Row>
        </Banner>
      </main>
      <Footer data={footerContent} />
    </>
  );
}
